function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.2 0H28.8C30.5673 0 32 1.43269 32 3.2V28.8C32 30.5673 30.5673 32 28.8 32H3.2C1.43269 32 0 30.5673 0 28.8V3.2C0 1.43269 1.43269 0 3.2 0ZM3.19922 3.19922V21.7386L9.60012 15.3377L15.2002 20.9378L25.6009 10.5371L28.7992 13.7354V3.19922H3.19922ZM3.19922 28.7992V26.2641L9.60012 19.8632L18.5361 28.7992H3.19922ZM28.7992 28.7992H23.0616L17.4629 23.2006L25.6009 15.0626L28.7992 18.2609V28.7992ZM19.2016 9.60078C19.2016 6.94981 17.0525 4.80078 14.4016 4.80078C11.7506 4.80078 9.60156 6.94981 9.60156 9.60078C9.60156 12.2517 11.7506 14.4008 14.4016 14.4008C17.0525 14.4008 19.2016 12.2517 19.2016 9.60078ZM12.8008 9.6C12.8008 8.71634 13.5171 8 14.4008 8C15.2844 8 16.0008 8.71634 16.0008 9.6C16.0008 10.4837 15.2844 11.2 14.4008 11.2C13.5171 11.2 12.8008 10.4837 12.8008 9.6Z"
});

var SvgPhoto = function SvgPhoto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photo.0852d771.svg";
export { ForwardRef as ReactComponent };